import * as universal from '../entries/pages/blog/_page.ts.js';
import stylesheet_4 from '../stylesheets/4.js';
import stylesheet_6 from '../stylesheets/6.js';
import stylesheet_19 from '../stylesheets/19.js';
import stylesheet_9 from '../stylesheets/9.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/blog/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/blog/+page.ts";
export const imports = ["_app/immutable/nodes/5.02dc49c8.js","_app/immutable/chunks/BlogContentCard.3c3d172f.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/index.1673eb25.js","_app/immutable/chunks/each.15f1f0ab.js","_app/immutable/chunks/index.852d6942.js","_app/immutable/chunks/Wrapper.a05beb49.js","_app/immutable/chunks/Input.407603bd.js"];
export const stylesheets = ["_app/immutable/assets/5.698818b7.css","_app/immutable/assets/BlogContentCard.ad128bc8.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Input.8fc26899.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/5.698818b7.css": stylesheet_4,
	"_app/immutable/assets/BlogContentCard.ad128bc8.css": stylesheet_6,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_19,
	"_app/immutable/assets/Input.8fc26899.css": stylesheet_9
});
